import "../Myprojects.css"
import React, { useState,useEffect } from "react";
import { FILES_URL } from '../../../../configs/AppConfig';



const OverviewTr = ({data}) => {
    //   const [formInputs , setFormInputs] = useState({
    //         teamSize:"",
    //         class: "A",
    //       });

    //   const success = () => {
    //        message.success('Your Challenge careated successfully');
    //       };

    //     const { id } = useParams();
    //     const token = localStorage.getItem('token');
    //     const decoded = jwtDecode(token);
    //     const teacherId = decoded.id;
       
    //       const assignProject = async()=>{
    //       await api.post(`${API_BASE_URL}assigned-projects`,{
    //       // points: formInputs.points.trim(),
    //       teamSize: formInputs.teamSize.trim(),
    //       class: "A",
    //       teacher : teacherId,
    //       project : id

    //       })
    //     .then(function (response) {
    //               console.log("handlesubmitffff  ", response.data)
    //           // setData(response.data)
    //     }).catch(error => {
    //       console.log("handlesubmit error for blog get ", error)
    //     });
    //     }  

    //   const handleSubmit = (event) => {
    // event.preventDefault();
    // assignProject()
    // success();
    //   setFormInputs({
    //       class:"",
    //       teamSize:"",
    //     })   
    // }
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} className="my-component"/>
  );
}


  return (
    <div>
      {/* <Header /> */}
       <div className="proOverview proOverviewMrg ">
        <div className="proOverviewChild">
        <h4 className="h4Create">Introduction : </h4>
                <MyComponent htmlContent={data.details?.introduction}/>
                </div>
       <div className="proOverviewChild">
          <h4 className="h4Create">NGSS Integration & Cross-Disciplinary Connections : </h4> 
              <MyComponent htmlContent={data.details?.ngssCross}/>
                 </div>
      </div>
      <div className="projectPic" style={{backgroundImage:`url(${FILES_URL}${data.coverImg?.url})`}}></div>

    </div>
  );
};

export default OverviewTr;
